import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Categoria, Mercaderia, Usuario } from 'src/app/model/index.model';
import {
  ApiService,
  WorkshoppingService,
} from 'src/app/service/index.service';
import { UturuncoUtils } from 'src/app/utils/uturuncoUtils';
import { environment } from 'src/environments/environment';
import { ItemViewComponent } from '../item-view/item-view.component';
import { ContenedorRegLogComponent } from 'src/app/pages/user/componentes/custom/contenedor-reg-log/contenedor-reg-log.component';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-shoping-cart',
  templateUrl: './shoping-cart.component.html',
  styleUrls: ['./shoping-cart.component.scss'],
  providers: [WorkshoppingService]
})
export class ShopingCartComponent implements OnInit {
  isMobile = window.innerWidth <= 768;

  proccess: Boolean;
  public search: String;
  public oldSearch: String;
  public cotizacion: any;
  public cantidadart: number = 0
  cantidad$ = this.wsdl.cantidad$;
  conf: any
  url: string = environment.configUrl;

  selectedGroups: number[] = [];



  public categs: any[] = [];
  public filter: string = 'Todas las Categorias';

  /* Searcheable table Filter */
  public limit: number;
  public page: number;
  public nextPage: number;
  public prevPage: number;
  public lastPage: number;
  public count: number;
  public limits: number[] = [6, 12, 24, 48, 96];

  setPage(page) {
    this.page = page;
    this.getCatalogo();
  }

  itemsM: Mercaderia[];
  itemsC: Categoria[];
  itemSel: Mercaderia;
  marcas: any[];
  usuario: Usuario;
  constructor(
    private route: Router,
    private modalService: NgbModal,
    private http: HttpClient,
    private wsdl: WorkshoppingService, private wsdlApi: ApiService) {
    this.itemsC = [];
    this.itemsM = [];
    this.proccess = false;
    this.limit = 6;
    this.page = 1;
  }

  async ngOnInit() {

    this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))

    await this.obtenerCategoria();
    await this.getCatalogo();
    this.wsdl.registrarCliente();
    this.wsdl.cargarCarrito();


    this.http.get(this.url).subscribe(res => {
      this.conf = res;
      this.marcas = this.conf.marcas
      if (this.conf.dolar === true) {
        this.getCotizacion();
      } else {
        this.cotizacion = 1
      }
    });


    /*
     this.wsdl.getConfig().then(config => {
      document.documentElement.style.setProperty('--primary-color', config.colorPrimary);
      document.documentElement.style.setProperty('--primary-color-dark', config.colorPrimaryDark);
      document.documentElement.style.setProperty('--background-color', config.background || '#f9f9f9');
    });
    */

  }

  async getCotizacion() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getUsd().then();
      const result = JSON.parse(JSON.stringify(data));
      this.cotizacion = result.venta;
      console.log('Cotización obtenida:', this.cotizacion);
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }
  oldCategs
  oldGroups
  async getCatalogo() {
    try {
      this.proccess = true;
      if (this.search === undefined) {
        this.search = '';
      }
      let d = this.oldSearch !== this.search;
      if (d) {
        this.limit = 6;
        this.page = 1;
        this.oldSearch = this.search;
      }

      // Verifica si cambió la búsqueda o las categorías/subcategorías
      const searchChanged = this.oldSearch !== this.search;
      const categsChanged = JSON.stringify(this.oldCategs) !== JSON.stringify(this.categs);
      const groupsChanged = JSON.stringify(this.oldGroups) !== JSON.stringify(this.selectedGroups);

      // Si cambia búsqueda, categoría o grupo => reinicia paginación
      if (searchChanged || categsChanged || groupsChanged) {
        this.limit = 6;
        this.page = 1;
        this.oldSearch = this.search;
        this.oldCategs = [...this.categs];
        this.oldGroups = [...this.selectedGroups];
      }

      let c = this.search;
      let result;
      if (this.categs.length == 0) {
        let data = await this.wsdlApi
          .getCatalogo(c, this.page, this.limit)
          .then();
        result = JSON.parse(JSON.stringify(data));
      } else {
        let data = await this.wsdlApi
          .getCatalogoCustom(c, this.categs, this.page, this.limit, this.selectedGroups)
          .then();
        result = JSON.parse(JSON.stringify(data));
      }
      if (result.code == 200) {
        this.itemsM = result.data.docs;

        this.page = parseInt(result.data.paginate.page);
        this.lastPage = parseInt(result.data.paginate.lastPage);
        this.nextPage = parseInt(result.data.paginate.nextPage);
        this.prevPage = parseInt(result.data.paginate.prevPage);
        this.count = parseInt(result.data.paginate.count);
      } else if (result.code === 401) {
        // logout app o refresh token
      } else {
        this.itemsM = [];
        UturuncoUtils.showToas(result.msg, 'error');
      }
    } catch (error) {
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
    console.log('Items M:', this.itemsM);
  }

  async obtenerCategoria() {
    try {
      this.proccess = true;
      let data = await this.wsdlApi.getCategoria().then();
      const result = JSON.parse(JSON.stringify(data));

      console.log("COSAS", result)
      if (result.code == 200) {

        this.itemsC = result.data.map((c: any) => ({
          ...c,
          expanded: false
        }));

        console.log(this.itemsC)

      } else if (result.code === 401) {
      } else {
        this.itemsC = [];
        UturuncoUtils.showToas(result.msg, 'error');
      }
    } catch (error) {
      console.log("cat", error)
      this.proccess = false;
    } finally {
      this.proccess = false;
    }
  }

  toggleCategoria(id: number) {
    this.itemsC = this.itemsC.map((c: any) =>
      c.id === id ? { ...c, expanded: !c.expanded } : c
    );
  }

  updateSelectedGrupo(event: any, categoriaId: number) {
    const grupoId = parseInt(event.target.value);
    const checked = event.target.checked;

    if (checked) {
      // Agrego grupo
      if (!this.selectedGroups.includes(grupoId)) {
        this.selectedGroups.push(grupoId);
      }

      // Agrego la categoría correspondiente si no está
      if (!this.categs.includes(categoriaId)) {
        this.categs.push(categoriaId);
      }

    } else {
      // Quito grupo
      this.selectedGroups = this.selectedGroups.filter(g => g !== grupoId);

      // Si ya no quedan grupos de esa categoría, elimino también la categoría
      const quedanGrupos = this.selectedGroups.some(g => {
        // buscá si alguno de los grupos seleccionados pertenece a la misma categoría
        const cat: any = this.itemsC.find(c => c.id === categoriaId);
        return cat?.grupos?.some(gr => gr.id === g);
      });

      if (!quedanGrupos) {
        this.categs = this.categs.filter(c => c !== categoriaId);
      }
    }

    console.log('Grupos seleccionados:', this.selectedGroups);
    console.log('Categorias seleccionadas:', this.categs);

    this.getCatalogo();
  }

  isCategoriaChecked(categoria: any): boolean {
    if (!categoria.grupos || categoria.grupos.length === 0) {
      return false; // nunca debe estar marcada si no tiene grupos
    }
    const grupoIds = categoria.grupos.map((g: any) => g.id);
    return grupoIds.every((id: number) => this.selectedGroups.includes(id));
  }

  isCategoriaIndeterminate(categoria: any): boolean {
    if (!categoria.grupos || categoria.grupos.length === 0) {
      return false; // nunca indeterminado si no tiene grupos
    }
    const grupoIds = categoria.grupos.map((g: any) => g.id);
    const seleccionados = grupoIds.filter((id: number) =>
      this.selectedGroups.includes(id)
    );
    return seleccionados.length > 0 && seleccionados.length < grupoIds.length;
  }

  toggleCategoriaCheck(categoria: any, event: any) {
    if (!categoria.grupos || categoria.grupos.length === 0) {
      return; // no hacer nada si no tiene grupos
    }

    const checked = event.target.checked;
    const grupoIds = categoria.grupos.map((g: any) => g.id);

    if (checked) {
      // Selecciono todos los grupos de la categoría
      grupoIds.forEach((id: number) => {
        if (!this.selectedGroups.includes(id)) {
          this.selectedGroups.push(id);
        }
      });
      if (!this.categs.includes(categoria.id)) {
        this.categs.push(categoria.id);
      }
    } else {
      // Desmarco todos los grupos de esa categoría
      this.selectedGroups = this.selectedGroups.filter(g => !grupoIds.includes(g));
      this.categs = this.categs.filter(c => c !== categoria.id);
    }

    console.log('Grupos seleccionados:', this.selectedGroups);
    console.log('Categorias seleccionadas:', this.categs);
    this.getCatalogo();
  }

  updateSelectedCateg(event) {
    if (event.target.checked) {
      if (this.categs.indexOf(parseInt(event.target.name)) < 0) {
        this.categs.push(parseInt(event.target.name));
      }
    } else {
      if (this.categs.indexOf(parseInt(event.target.name)) > -1) {
        this.categs.splice(this.categs.indexOf(parseInt(event.target.name)), 1);
      }
    }

    if (this.categs.length == this.itemsC.length || this.categs.length == 0) {
      this.filter = 'Todas las Categorias';
    } else {
      this.filter = 'Tiene ' + this.categs.length + ' Categorias';
    }
    this.getCatalogo()
  }

  addItem(item: Mercaderia) {
    this.wsdl.itemSel(item);
    this.itemSel = item

    // Trigger animación en el botón
    const badge = document.querySelector('.badge');
    if (badge) {
      badge.classList.remove('animate__heartBeat');
      void (badge as HTMLElement).offsetWidth;
      // fuerza reflow
      badge.classList.add('animate__heartBeat');
    }
  }

  openModal(product: Mercaderia) {
    const modalRef = this.modalService.open(ItemViewComponent, {
      size: 'lg',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });
    const user = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC));
    console.log("rol", user)
    modalRef.componentInstance.product = product;
    modalRef.componentInstance.cotizacion = this.cotizacion;
    modalRef.componentInstance.rol = user?.rol?.id


    modalRef.result.then(
      result => {
        for (let index = 0; index < result; index++) {
          this.addItem(product)
        }
      },
      reason => {
        console.log('Modal descartado con:', reason);
      }
    );
  }

  openModalLogin() {
    console.log("usuario", this.usuario)
    if (this.usuario) {
      this.route.navigate(["/user/dashboard/perfil"])
      return
    }

    const modalRef = this.modalService.open(ContenedorRegLogComponent, {
      size: 'md',
      centered: true,
      keyboard: true       // permite cerrar con ESC
    });

    //modalRef.componentInstance.product = product;

    modalRef.result.then(
      result => {
        this.usuario = JSON.parse(UturuncoUtils.getSession(UturuncoUtils.UC))
        console.log('Modal cerrado con:', result);
      },
      reason => {
        console.log('Modal descartado con:', reason);
      }
    );
  }

  focusSearch() {
    const input = document.querySelector('.search-bar input') as HTMLInputElement;
    if (input) {
      input.focus();
      input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  shareProduct(item: Mercaderia) {
    // Ajusta estos campos según tu modelo real de producto
    const nombre = item.nombre || 'Producto DIVLEC';
    const precioCon = item.precioCon || 0;
    const precioMayorista = item.precioMay || precioCon * 0.85; // ejemplo fallback
    const descripcion = item.descripcion || 'Producto de alta calidad para tus necesidades diarias.';
    const sku = item.serie || '—';
    const url = `${window.location.origin}/#/producto/${item.id}`;

    // Texto atractivo y estructurado (con emojis para mayor impacto visual en WhatsApp)
    const shareText =
      `🔥 ${nombre.toUpperCase()} 🔥

${descripcion.trim()}

💰 Precio contado: $${(precioCon * this.cotizacion).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.')}

💼 Ofertas especiales:
• Mayorista: $${(precioMayorista * this.cotizacion).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.')} c/u   (llevando ${item.cantOferta} o más unidades)

📦 SKU: ${sku}
🚚 Envíos a todo el país | Retiro en sucursales

📍 Sucursales:
  ${this.conf.dir} – 📞 ${this.conf.tel}

🌐 ${this.conf.name}
🖥️ ${this.conf.tit}

¡Consultá stock y reservá el tuyo ahora! 👇
${url}`;

    // Compartir nativo (mejor experiencia en móviles)
    if (navigator.share) {
      navigator.share({
        title: `${nombre} - $${(precioCon * this.cotizacion).toFixed(0)}`,
        text: shareText,
        //url: url
      }).then(() => {
        console.log('Producto compartido exitosamente');
      }).catch(err => {
        console.error('Error al compartir:', err);
        this.fallbackCopyToClipboard(shareText);
      });
    } else {
      // Fallback más completo: copiar el texto atractivo completo
      this.fallbackCopyToClipboard(shareText);
    }
  }

  // Método auxiliar para fallback
  private fallbackCopyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      alert('¡Texto para compartir copiado al portapapeles!\nPegalo en WhatsApp o donde quieras.');
    }).catch(err => {
      console.error('Error al copiar:', err);
      alert('No se pudo copiar automáticamente. Por favor copia manualmente el enlace:\n' + text);
    });
  }

}
